if (!customElements.get('linked-products-slider')) {
  customElements.define(
    'linked-products-slider',
    class LinkedProductsSlider extends HTMLElement {
      connectedCallback() {
        this.productsWrap = this.querySelector('.products-grid-wrap');
        this.products = this.querySelector('.products-grid');
        this.prevButton = this.querySelector('.swiper-button-prev');
        this.nextButton = this.querySelector('.swiper-button-next');

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items || '3', 10);
        this.tabletItems = parseInt(this.dataset.tabletItems || '2', 10);
        this.sliderInstance = false;
        this.gridClass = 'f-grid';

        if (!this.enableSlider || !this.productsWrap || !this.products) return;

        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (typeof this.sliderInstance === 'object') {
          this.destroySlider();
        }

        this.initSlider();
      }

      initSlider() {
        if (!this.productsWrap || !this.products) return;

        const columnGap = window.getComputedStyle(this.products).getPropertyValue('--column-gap');
        const gapValue = parseFloat(columnGap.replace('rem', '')) || 2;
        const spaceBetween = gapValue * 10;

        this.sliderOptions = {
          slidesPerView: 1.12,
          spaceBetween: spaceBetween,
          threshold: 2,
          loop: false,
          watchOverflow: true,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          breakpoints: {
            768: {
              slidesPerView: Math.min(this.tabletItems, 2),
            },
            1280: {
              slidesPerView: this.items,
            },
          },
        };

        this.products.classList.remove(this.gridClass);
        this.sliderInstance = new window.FoxTheme.Carousel(this.productsWrap, this.sliderOptions);
        this.sliderInstance.init();
        this.bindSliderState();
        this.updateNavigationState();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.products.classList.add(this.gridClass);
        this.sliderInstance = false;
      }

      bindSliderState() {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        this.sliderInstance.slider.on('init', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('slideChange', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('reachBeginning', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('reachEnd', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('fromEdge', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('lock', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('unlock', this.updateNavigationState.bind(this));
        this.sliderInstance.slider.on('resize', this.updateNavigationState.bind(this));
      }

      updateNavigationState() {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        const slider = this.sliderInstance.slider;
        const hidePrev = slider.isBeginning || slider.isLocked;
        const hideNext = slider.isEnd || slider.isLocked;

        if (this.prevButton) {
          this.prevButton.classList.toggle('is-hidden', hidePrev);
          this.prevButton.disabled = hidePrev;
          this.prevButton.setAttribute('aria-hidden', hidePrev ? 'true' : 'false');
          this.prevButton.setAttribute('tabindex', hidePrev ? '-1' : '0');
        }

        if (this.nextButton) {
          this.nextButton.classList.toggle('is-hidden', hideNext);
          this.nextButton.disabled = hideNext;
          this.nextButton.setAttribute('aria-hidden', hideNext ? 'true' : 'false');
          this.nextButton.setAttribute('tabindex', hideNext ? '-1' : '0');
        }
      }
    }
  );
}
